import React from 'react';
import './chatTitle.css';
import moment from 'moment';

const ChatTitle = (props) => {
  const {
    createdDate,
    ipAddress,
  } = props;
  const friendlyTimestamp = moment(createdDate).format('dddd, DD MMM YYYY, HH:mm');
  return (
    <div className={'chatTitle'}>
      {friendlyTimestamp}
      {ipAddress && (
        <div className={'chatTitleIp'} style={{ fontSize: '0.8em', opacity: 0.7, marginTop: 2 }}>
          {`Από: ${ipAddress}`}
        </div>
      )}
    </div>
  );
};

export default ChatTitle;
